import { render, staticRenderFns } from "./Centre_productie_dialog.vue?vue&type=template&id=39ffae92"
import script from "./Centre_productie_dialog.vue?vue&type=script&lang=js"
export * from "./Centre_productie_dialog.vue?vue&type=script&lang=js"
import style0 from "./Centre_productie_dialog.vue?vue&type=style&index=0&id=39ffae92&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports